import { Button } from '@bambi/component-library/src/components/Button/Button';
import { FlagIcon } from '@heroicons/react/24/outline';
import { useDispatch } from 'react-redux';


import { setShowTripSubscriptionModal } from '../trip-subscriptions.slice';

export function TripSubscriptionEmptyState() {
  const dispatch = useDispatch();

  return (
    <div className="flex justify-center px-[24px] py-12">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-200">
          <FlagIcon className="mx-auto h-6 w-auto text-gray-700" />
        </div>
        <p className="text-gray-400">There are no trip subscriptions to show</p>
        <div className="mt-3 text-gray-700">
          <Button
            variant="primary"
            onClick={() => dispatch(setShowTripSubscriptionModal(true))}
          >
            Add a Trip Subscription
          </Button>
        </div>
      </div>
    </div>
  );
}
